// @ts-nocheck
import React, { FC, useState, useEffect } from 'react';
import { whichAuth as getAuth } from '../../getAuth';
import { userState, viewState } from '../../atoms';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { format } from "date-fns";
import CurrencyFormat from 'react-currency-format';
import { viewPayments, viewBills, REST_API_URL } from '../../constants/global';
import { handleErrors } from '../../utils/handleErrors';
import {
  IonCard,
  IonCardContent,
  IonCardTitle,
  IonCol,
  IonGrid,
  IonHeader,
  IonIcon,
  IonItem,
  IonRow,
  IonTitle,
  IonText,
  IonPopover,
  IonContent
} from '@ionic/react';
import InfoIcon from "../../assets/info.svg";
import WalletIcon from "../../assets/wallet.svg";
import DocumentIcon from "../../assets/document.svg";
import DollarIcon from "../../assets/dollar.svg";
import './PaymentInfo.css'

const PaymentInfo: FC = () => {
  
  const user = useRecoilValue(userState);
  const setView = useSetRecoilState(viewState);
  
  const [invoiceTotal, setInvoiceTotal] = useState<null, any>(null);
  const [paymentTotal, setPaymentTotal] = useState<number>(0);

  const getInvoiceTotalForMonth = () => getAuth()?.currentUser?.getIdToken().then(token =>
    fetch(user._links.self.href + '/invoices/monthTotal', {headers: {'Authorization': 'Bearer ' + token}})
      .then(handleErrors)
      .then(total => setInvoiceTotal(total/100))
      .catch(() => setInvoiceTotal(null)));
      
  const getPaymentTotal = () => getAuth()?.currentUser?.getIdToken().then(token =>
    fetch(REST_API_URL + '/payments/search/sumAmount', {headers: {'Authorization': 'Bearer ' + token}})
      .then(handleErrors)
      .then(total => setPaymentTotal(total/100))
      .catch(() => 0));
      
  useEffect(() => {
    getInvoiceTotalForMonth();
    user.admin && getPaymentTotal();
  }, []);

  let paymentInfo = user ? user.paymentInfo : {};

  return (
    <IonHeader className="payment-info-header">
      <IonGrid>
        <IonRow className="payment-info-row">
          <IonCol size="12">
            {user?.firstName ? (
              <IonTitle className="payment-info-header-title">Hello, {user?.firstName}!</IonTitle>
            ) : (
              <IonTitle className="payment-info-header-title">Welcome to Billsmoov</IonTitle>
            )}
          </IonCol>
          { user?.paymentOption === 'SMOOV' &&
          <>
            <IonCol size="4" className="payment-info-col">
              <IonCard className="payment-info-card active" onClick={() => setView(viewPayments)}>
                <IonItem className="payment-info-item">
                  <IonIcon src={WalletIcon} className="payment-info-item-icon" />
                </IonItem>
                <IonCardContent className="payment-info-card-content">
                  <IonCardTitle className="payment-info-card-title">Next payment {paymentInfo?.nextPaymentDate && !!paymentInfo?.nextPaymentAmount && format(new Date(paymentInfo?.nextPaymentDate), 'dd MMM')}</IonCardTitle>
                  <IonText className="payment-info-card-price">
                    {paymentInfo?.nextPaymentAmount !== null ?
                      <CurrencyFormat
                        value={isNaN(paymentInfo?.nextPaymentAmount) ? 0 : paymentInfo?.nextPaymentAmount/100}
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        prefix='$'
                        displayType='text'
                      /> : '$0.00'
                    }
                  </IonText>
                </IonCardContent>
                <IonIcon id="nextPaymentAmountInfo" src={InfoIcon} className="payment-info-icon-info" />
                <IonPopover trigger="nextPaymentAmountInfo" triggerAction="hover">
                  <IonContent class="ion-padding">This is how much you will be charged on your next payment date.</IonContent>
                </IonPopover>
              </IonCard>
            </IonCol>
            <IonCol size="4" className="payment-info-col bills-this-month">
              <IonCard className="payment-info-card active" onClick={() => setView(viewBills)}>
                <IonItem className="payment-info-item">
                  <IonIcon src={DocumentIcon} className="payment-info-item-icon" />
                </IonItem>
                <IonCardContent className="payment-info-card-content">
                  <IonCardTitle className="payment-info-card-title">Bills this month</IonCardTitle>
                  <IonText className="payment-info-card-price">
                    {invoiceTotal !== null ?
                      <CurrencyFormat
                        value={invoiceTotal}
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        prefix='$'
                        displayType='text'
                      /> : '$0.00'
                    }
                  </IonText>
                </IonCardContent>
                <IonIcon id="billsThisMonthInfo" src={InfoIcon} className="payment-info-icon-info" />
                <IonPopover trigger="billsThisMonthInfo" triggerAction="hover">
                  <IonContent class="ion-padding">This is the total value of bills you have approved to be paid in the current month.</IonContent>
                </IonPopover>
              </IonCard>
            </IonCol>
            <IonCol size="4" className="payment-info-col">
              <IonCard className="payment-info-card active" onClick={() => setView(viewPayments)}>
                <IonItem className="payment-info-item">
                  <IonIcon src={DollarIcon} className="payment-info-item-icon" />
                </IonItem>
                <IonCardContent className="payment-info-card-content">
                  <IonCardTitle className="payment-info-card-title">Balance</IonCardTitle>
                  <IonText className="payment-info-card-price">
                    <CurrencyFormat
                      value={user.admin ? paymentTotal : paymentInfo?.balance/100}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      prefix='$'
                      displayType='text'
                    />
                  </IonText>
                </IonCardContent>
                <IonIcon id="balanceInfo" src={InfoIcon} className="payment-info-icon-info" />
                <IonPopover trigger="balanceInfo" triggerAction="hover">
                  <IonContent class="ion-padding">This is the difference between the total bills paid by Billsmoov and your repayments.</IonContent>
                </IonPopover>
              </IonCard>
            </IonCol>
          </>
          }
        </IonRow>
      </IonGrid>
    </IonHeader>
  );
}

export default PaymentInfo;
